import { DestroyRef, inject, Signal, signal } from '@angular/core';

/**
 * A signal that tracks a media query, so components branch on the same
 * breakpoint the stylesheet uses instead of sampling window.innerWidth.
 * Call it in an injection context: the listener is removed on destroy.
 */
export function matchMediaSignal(query: string): Signal<boolean> {
    const mediaQuery = window.matchMedia(query);
    const matches = signal(mediaQuery.matches);
    const onChange = (event: MediaQueryListEvent) => matches.set(event.matches);

    mediaQuery.addEventListener('change', onChange);
    inject(DestroyRef).onDestroy(() => mediaQuery.removeEventListener('change', onChange));

    return matches.asReadonly();
}
